define('AwaLabs.FacetCellFields', [
    'Backbone',
    'underscore',
    'Utils',
    'facets_faceted_navigation_item_empty_template.tpl'
], function AwalabsFacetCellFields(
    Backbone,
    _,
    Utils
) {
    'use strict';

    return {
        mountToApp: function mountToApp(application) {
            var PLP = application.getComponent('PLP');
            var Layout = application.getComponent('Layout');

            function itemForContext(context) {
                // Native getItemsInfo deep-copies the complete result collection.
                // Resolve and copy only this row when the same native PLP contract is present.
                // Keep the public API path for other SuiteCommerce implementations.
                var nativeGetter = false;
                try {
                    // Do not bypass another extension's customized public API.
                    nativeGetter = /^function\(\)\{if\(this\._isViewFromComponent\(\)\)return[$A-Z_a-z][$\w]*\.deepCopy\(this\.current_view\.model\.get\((?:"items"|'items')\)\);?\}$/.test(
                        Function.prototype.toString.call(PLP.getItemsInfo).replace(/\s/g, '')
                    );
                } catch (error) { /* Use the public API when its implementation is unknown. */ }
                if (nativeGetter && typeof PLP._isViewFromComponent === 'function' &&
                        Utils && typeof Utils.deepCopy === 'function') {
                    if (!PLP._isViewFromComponent()) return undefined;
                    var view = PLP.current_view;
                    var items = view && view.model && typeof view.model.get === 'function' && view.model.get('items');
                    if (items instanceof Backbone.Collection && items.models.every(function(item) {
                            return item && typeof item.get === 'function';
                        })) {
                        var item = _.find(items.models, function(row) {
                            return row.get('internalid') === context.itemId;
                        });
                        return item ? Utils.deepCopy(item) : undefined;
                    }
                }
                return _.find(PLP.getItemsInfo(), function(item) {
                    return item.internalid === context.itemId;
                });
            }
            Layout.addToViewContextDefinition('Facets.ItemCell.View', 'model', 'object', function modelContext(context) {
                return itemForContext(context);
            });
            Layout.addToViewContextDefinition('Facets.ItemCell.View', 'mainImage', 'string', function modelContext(context) {
                var model = itemForContext(context);
                var mappedImages = model && model.keyMapping_images;
                var mainImages = model && model.itemimages_detail &&
                    model.itemimages_detail.main && model.itemimages_detail.main.urls;
                var image = mappedImages && mappedImages[0] && mappedImages[0].url;
                if (mainImages && mainImages[0]) {
                    image = mainImages[0].url;
                }
                return image || '';
            });
        }
    };
});
